export const environment = {
    production: false,
    hmr: false,
    recaptcha:'6Lf6WQAfAAAAAODIEsSEhWPbfkCDx_azG_QgRsXy', //'6LdavQAfAAAAABrvaiTh8RjYk_eAJhB2A-YaPjpj'
    APIURL: 'https://gcadaapi-dev.azurewebsites.net/api',
    IMAGEURL: 'https://gcadadev.blob.core.windows.net/gcada/',
    //APIURL: 'http://localhost:5000/api',
    // IMAGEURL: 'http://localhost:63425/gcada'
};